// extracted by mini-css-extract-plugin
module.exports = {"diagonal-stripes":"channel-danger-zone_diagonal-stripes__PRhAT","button-overlay":"channel-danger-zone_button-overlay__CCfvm","hide":"channel-danger-zone_hide__h6b3x"};